import argumentDataSources from '@/schema/argumentDataSources';

const getWorkflowAdvancedFields = ({ timezones, environments, dataSource }) => {
  const fields = [];

  if (timezones && timezones.length > 0) {
    fields.push({ key: 'timezone', name: 'Time Zone', placeholder: 'Select Time Zone', dataType: 'list', options: timezones, nullable: true, nullableLabel: 'None' });
  }

  const envOptions = environments?.map((env) => ({ label: env.name, value: env.id })) || [];

  if (environments && environments.length > 0 && dataSource !== argumentDataSources.appAuthenticationInstance) {
    fields.push({
      key: 'environmentId',
      name: 'Workflow Environment',
      placeholder: 'Select Environment',
      dataType: 'list',
      options: envOptions,
      nullable: true,
      nullableLabel: 'None'
    });
  }

  return fields;
};

export default getWorkflowAdvancedFields;
